import React, { useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import StatusComp from "../../../components/StatusComp";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  dummyimage,
  edit_icon,
  eye_icon,
  green_icon,
  red_icon,
  user,
  view_icon,
} from "../../../assets/imgs";
import { post, get } from "../../../Services/ApiHandler";
import { URL as API } from "../../../Services/Constant";
import { cityList, countriesList, stateList } from "../../redux/api/Country";
import AlreadyComPopup from "../../../components/Popup/AlreadyComPopup";

const SubAdminGenerate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [logo, setLogo] = useState();
  const [ownerImg, setOwnerImg] = useState();
  const [companyID, setCompanyID] = useState(location?.state?.data?.id ?? "");
  const [email_verified, setEmail_verified] = useState(0);
  const [fullData, setFullDate] = useState({});
  const [popup, setPopup] = useState(false);

  const createdAt = moment().format("DD-MM-YYYY");

  const comDataObj = {
    email: "",
    name: "",
    phone: "",
    role_id: "",
    city: "",
    state: "",
    country: "",
    password: "",
    password_confirmation: "",
  };

  const [comData, setComData] = useState(comDataObj);
  const [admindetails, setAdminDetails] = useState({});
  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState();
  const [siteErrors, setSiteErrors] = useState({});
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);
  const [flagEmail, setFlagEmail] = useState(0);

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [companyKnfRole, setCompanyKnfRole] = useState([]);
  const [locList, setLoclist] = useState([]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  console.log("comData", comData);

  const getKfnRole = () => {
    get(API.SUBADMIN_ROLES)
      .then((res) => {
        if (res?.status == "success") {
          setCompanyKnfRole(res?.roles);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocationList = () => {
    get(API.LOCATION_LIST)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = () => {
    get(API.SUBADMIN_VIEW + location?.state?.data?.id)
      .then((res) => {
        let data = res?.user_data;
        setFullDate(data);
        if (data?.email_verified) {
          setEmail_verified(data?.is_email_verified);
        }

        let country = countriesList?.find(
          (item) => item?.name == res?.user_data?.country,
        );
        let state = stateList?.find(
          (item) => item?.name == res?.user_data?.state,
        );
        let city = cityList?.find((item) => item?.name == res?.user_data?.city);

        let ob = {
          email: "",
          name: "",
          phone: "",
          role_id: "",
          city: "",
          state: "",
          country: "",
        };

        if (data?.id) {
          setCompanyID(data?.id);
        }

        if (data?.name) {
          ob.name = data?.name;
        }

        if (data?.email) {
          ob.email = data?.email;
        }
        if (data?.phone) {
          ob.phone = data?.phone;
        }

        if (data?.role_id) {
          ob.role_id = data?.role_id;
        }

        if (data?.country) {
          ob.country = data?.country;
        }

        if (data?.state) {
          ob.state = data?.state;
        }

        if (data?.city) {
          ob.city = data?.city;
        }

        setComData(ob);
        setEmailCheckFlag(1);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getKfnRole();
    // getLocationList();

    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    const singaporeMobileRegex = /^[89]\d{7}$/;

    if (comData?.name?.length == 0) newErrors.name = "Name is required";
    if (comData?.role_id?.length == 0) newErrors.role_id = "Select Role";
    if (comData?.country?.length == 0) newErrors.country = "Select Country";
    if (comData?.state?.length == 0) newErrors.state = "Select State";
    if (comData?.city?.length == 0) newErrors.city = "Select City";
    if (comData?.email?.length == 0 || !emailRegex.test(comData?.email))
      newErrors.email = "Valid Email is required";
    // if (
    //   !comData?.mobile
    //   // || !singaporeMobileRegex.test(comData?.mobile)
    // ) {
    //   newErrors.mobile = "Enter valid 9-digit Singapore number";
    // }
    if (
      !comData?.phone ||
      (comData?.phone?.length !== 8 && comData?.phone?.length !== 10)
    ) {
      newErrors.phone = "Enter valid 8-digit or 10-digit mobile number";
    }
    if (comData?.person?.length == 0)
      newErrors.person = "Person Name is required";

    if (!companyID) {
      // if (comData?.password?.length == 0 || comData?.password.length < 6)
      //   newErrors.password = "Password must be at least 6 characters";
      // if (comData?.confirmPassword !== comData?.password)
      //   newErrors.confirmPassword = "Passwords do not match";
      // if (!logo) newErrors.logo = "Company Logo is required";
      // if (!ownerImg) newErrors.ownerImg = "Primary Person image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (comData?.email?.length < 0) {
    //   setEmailCheckData({});
    // }
    setComData((prev) => ({ ...prev, [name]: value }));

    // clear specific error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  let user_ = companyKnfRole?.find((item) => item?.name == "Company User");

  const handleSubmit = () => {
    if (validate()) {
      const formdata = new FormData();
      formdata.append("name", comData?.name);
      formdata.append("email", comData?.email);
      formdata.append("phone", comData?.phone);
      formdata.append("role", comData?.role_id);
      formdata.append("city", comData?.city);
      formdata.append("state", comData?.state);
      formdata.append("country", comData?.country);
      // if (comData?.password) {
      //   formdata.append("password", comData?.password);
      // }
      // if (comData?.password_confirmation) {
      //   formdata.append(
      //     "password_confirmation",
      //     comData?.password_confirmation
      //   );
      // }
      if (companyID) {
        // formdata.append("type", user_?.id == comData?.role_id ? 1 : 2);
        formdata.append("type", 2);
        formdata.append("user_id", companyID);
      } else {
        formdata.append("type", 2);
      }

      if (comData?.knf_type) {
        formdata.append("knf_type", comData?.knf_type);
      }

      if (comData?.knf_role_id) {
        formdata.append("knf_role_id", comData?.knf_role_id);
      }

      if (companyID) {
        // formdata.append("_method", "PATCH");
        post(API.SUBADMIN_EDIT + companyID, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate(-1);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(API.SUBADMIN_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate(-1);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      //   console.log("Submit successful", comData);
    }
  };

  const handleLogoChange = (event) => {
    let image = event.target.files[0];
    if (image) {
      setLogo(image);
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };
  // console.log('logo', logo)

  const handlePrimaryImg = (event) => {
    let image = event.target.files[0];
    if (image) {
      setOwnerImg(image);
      setErrors((prev) => ({
        ...prev,
        ownerImg: "",
      }));
    }
  };

  const autoFetchData = (data_new) => {
    let data = {
      ...data_new?.user,
      company: {
        ...data_new?.company,
        site: data_new?.site,
      },
    };

    setEmailCheckData(data);
    if (data?.company?.id) {
      // setID(data?.company?.id);
    }

    if (data?.id) {
      setCompanyID(data?.id);
    }

    let ob = {
      id: "",
      company_name: "",
      name: "",
      email: "",
      role_id: "",
      phone: "",
      password: "",
      password_confirmation: "",
      location: "",
      city: "",
      state: "",
      country: "",
      email_verified: data?.id ? 1 : 0,
      is_email_verified: data?.is_email_verified,
      knf_type: data?.knf_type ?? "",
      knf_role_id: data?.knf_role_id ?? "",
    };

    if (data?.city) {
      ob.city = data?.city;
    }

    if (data?.state) {
      ob.state = data?.state;
    }

    if (data?.country) {
      ob.country = data?.country;
    }

    if (data?.id) {
      ob.id = data?.id;
    }

    if (data?.company?.logo) {
      setSelectedImage(data?.company?.logo);
    }

    if (data?.company?.name) {
      ob.company_name = data?.company?.name;
    }

    if (data?.company?.site?.address) {
      ob.address = data?.company?.site?.address;
    }
    if (data?.role_id) {
      ob.role_id = data?.role_id;
    }
    if (data?.company?.site?.location) {
      ob.location = data?.company?.site?.location;
    } else if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    if (data?.phone) {
      ob.phone = data?.phone;
    }

    if (data?.name) {
      ob.name = data?.name;
      // setType("edit");
    }

    if (data?.company?.logo) {
      ob.logo = data?.company?.logo;
    }

    if (data?.email) {
      ob.email = data?.email;
    } else {
      ob.email = comData?.email;
    }

    setComData(ob);
  };

  console.log("subAdminEmailCheckdata", emailCheckData);

  const emailCheck = () => {
    let formdata = new FormData();
    if (comData?.email?.length > 0) {
      formdata.append("email", comData?.email);
      post("user/" + API.EMAIL_CHECK, formdata)
        .then((res) => {
          setFlagEmail(0);
          if (res?.exists && location?.state?.type == "edit") {
            toast.error(res?.message);
            setEmailCheckFlag(0);
            let data = res?.userData?.[0];
            let emCheck = {
              ...data?.user,
              company: data?.company,
            };
            setAdminDetails(emCheck);
            if (emCheck?.id) {
              setPopup(true);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            // } else if (res?.exists && res?.message?.includes("admin")) {
          } else if (
            res?.exists &&
            res?.message == "This email is already an admin."
          ) {
            toast.error(res?.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            console.log(11);

            setEmailCheckFlag(1);
            if (res?.userData?.length > 0) {
              let data = res?.userData?.[0];
              if (data?.user?.knf_type >= 1 && data?.user?.knf_type <= 5) {
                autoFetchData(data);
              } else if (data?.user?.knf_type == null) {
                autoFetchData(data);
              } else {
                toast.error("Email ID already exists");
              }
            } else {
              let ob = {
                ...(location?.state?.type == "edit" ? comData : comDataObj),
                email: comData.email,
              };
              setComData(ob);
              setEmailCheckData({});
              if (location?.state?.type !== "edit") {
                toast("please enter all required fields");
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  const handleClosePopup = () => {
    setPopup(false);
    window.location.reload();
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Company"} type={type} />

      {popup && (
        <AlreadyComPopup
          setPopup={setPopup}
          admindetails={admindetails}
          locList={locList}
        />
      )}

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <div className="d-flex w-100 ac-jb">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Email ID<span className="text-danger">*</span>
            </p>
            {type == "edit" && (
              <p className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-12 mb-1 text-primary mx-2">
                {email_verified == 0
                  ? "Email Verified"
                  : "Email Verification pending"}
              </p>
            )}
          </div>
          <div className="d-flex">
            <input
              className="input-box"
              name="email"
              value={comData?.email}
              onChange={(even) => {
                setFlagEmail(1);
                // handleChange(even)
                if (location?.state?.type == "edit") {
                  handleChange(even);
                  setEmailCheckFlag(1);
                } else {
                  setComData(() => ({
                    ...comDataObj,
                    email: even.target.value,
                  }));
                  setEmailCheckFlag(0);
                }
              }}
              type="email"
              placeholder="Email ID"
              // disabled={type == "edit" ? true : false}
            />
            {/* {email_verified == 0 && ( */}
            {/* {comData?.email?.length > 1 && ( */}
            <button
              className={`email_check_btn ${
                !emailRegex?.test(comData?.email) ? "opacity-50" : ""
              }`}
              disabled={
                comData?.email?.length == 0
                  ? true
                  : // : type == "edit"
                    // ? true
                    false
              }
              onClick={() => {
                if (location?.state?.type == "edit") {
                  if (fullData?.email == comData?.email) {
                    toast.error("Same Email Entered");
                  } else {
                    emailCheck();
                  }
                } else {
                  emailCheck();
                }
              }}
            >
              Check
            </button>
            {/* )} */}
          </div>
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        {/* {emailCheckFlag == 1 && (  )} */}
        <>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Name<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="name"
              value={comData?.name}
              onChange={handleChange}
              type="text"
              placeholder="Name"
              disabled={
                emailCheckData?.name ? true : emailCheckFlag == 0 ? true : false
              }
            />
            {errors?.name && <p className="err">{errors?.name}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              Primary Singapore Mobile number
              <span className="text-danger">*</span>
            </p>
            <input
              name="phone"
              value={comData?.phone}
              maxLength={8}
              onChange={handleChange}
              className="input-box"
              type="text"
              placeholder="+65 Mobile number"
              disabled={
                emailCheckData?.phone
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            />
            {errors.phone && <p className="err">{errors.phone}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              Role<span className="text-danger">*</span>
            </p>
            <select
              name="role_id"
              value={comData?.role_id}
              onChange={handleChange}
              className="input-box"
              type="text"
              disabled={
                emailCheckData?.role_id
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            >
              <option>Select Role</option>
              {companyKnfRole?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
            {errors.role_id && <p className="err">{errors.role_id}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              Country<span className="text-danger">*</span>
            </p>
            <select
              name="country"
              value={comData?.country}
              onChange={handleChange}
              className="input-box"
              type="text"
              disabled={
                emailCheckData?.country
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            >
              <option>Select Country</option>
              {countriesList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {" "}
                    {item?.name}
                  </option>
                );
              })}
            </select>
            {errors.country && <p className="err">{errors.country}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              State<span className="text-danger">*</span>
            </p>
            <select
              name="state"
              value={comData?.state}
              onChange={handleChange}
              className="input-box"
              type="text"
              disabled={
                emailCheckData?.state
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            >
              <option>Select State</option>
              {stateList
                ?.filter((data) => data?.country_id == comData?.country)
                ?.map((item) => {
                  return (
                    <option value={item?.id} key={item?.id}>
                      {" "}
                      {item?.name}
                    </option>
                  );
                })}
            </select>
            {errors.state && <p className="err">{errors.state}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              City<span className="text-danger">*</span>
            </p>
            <select
              name="city"
              value={comData?.city}
              onChange={handleChange}
              className="input-box"
              type="text"
              disabled={
                emailCheckData?.city ? true : emailCheckFlag == 0 ? true : false
              }
            >
              <option>Select City</option>
              {cityList
                ?.filter((data) => data?.state_id == comData?.state)
                ?.map((item) => {
                  return (
                    <option value={item?.id} key={item?.id}>
                      {" "}
                      {item?.name}
                    </option>
                  );
                })}
            </select>
            {errors.city && <p className="err">{errors.city}</p>}
          </div>
        </>

        {/* {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Password
              {type !== "view" || type !== "edit" ? (
                <span className="text-danger">*</span>
              ) : (
                ""
              )}
            </p>
            <div className="input-box ac-jb ">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="password"
                value={comData?.password}
                onChange={handleChange}
                type={visible ? "text" : "password"}
                maxLength={20}
                placeholder="Password"
                disabled={emailCheckData?.company_id ?? false}
              />
              {!visible && (
                <img
                  src={eye_icon}
                  onClick={() => setVisible(!visible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {visible && (
                <VisibilityIcon
                  onClick={() => setVisible(!visible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>
        )} */}
        {/* {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Confirm Password{" "}
              {type !== "view" || type !== "edit" ? (
                <span className="text-danger">*</span>
              ) : (
                ""
              )}
            </p>
            <div className="input-box ac-jb">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="confirmPassword"
                value={comData?.confirmPassword}
                onChange={handleChange}
                type={confVisible ? "text" : "password"}
                maxLength={20}
                placeholder="Confirm Password"
                disabled={emailCheckData?.company_id ?? false}
              />
              {!confVisible && (
                <img
                  src={eye_icon}
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {confVisible && (
                <VisibilityIcon
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.confirmPassword && (
              <p className="err">{errors.confirmPassword}</p>
            )}
          </div>
        )} */}
      </div>
      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>

        {type != "view" && flagEmail == 0 && (
          <>
            {emailCheckData?.id ? (
              <button
                onClick={handleSubmit}
                className={` submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                  emailCheckData?.email == comData?.email ? "" : "opacity-50"
                }`}
                disabled={
                  emailCheckData?.email == comData?.email ? false : true
                }
              >
                {type == "edit" ? "Submit" : "Add"}
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                  emailCheckFlag == 1 ? "" : "opacity-50"
                }`}
                disabled={emailCheckFlag == 1 ? false : true}
              >
                {type == "edit" ? "Submit" : "Add"}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SubAdminGenerate;
